/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    global: {
        '@font-face': {
            fontFamily: 'Roboto',
            src: 'url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap")'
        },
        'html, body': {
            backgroundColor: 'white',
            color: 'gray.900',
            fontFamily: `"Roboto" , sans-serif`,
            fontWeight: '400',
            '-webkit-tap-highlight-color': 'transparent'
        },
        body: {
            minHeight: '100vh',
            overflowX: 'hidden'
        },
        '.react-target': {
            display: 'flex',
            minHeight: '100vh'
        },
        '#booxi': {
            zIndex: '100000'
        },
        'body.modal-open': {
            '--removed-body-scroll-bar-size': '0px',
            overflow: 'hidden',
            marginRight: '0px !important',
            width: '100vw'
        }
    }
}
